import { APICONFIG } from '@config/api.config';
import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { Dealers } from '.';
import { setRxdb } from '@helper/utils';
import { useCheckRxdb } from '@hooks/checkRxdb';
import { useGetRxDb } from '@hooks/getRxdbData';
import { ProfileData } from '../profile';

export const useDealersQuery = (): IQueryResponse<Array<Dealers[]>> => {
	const { isDbChecked, shouldFetch } = useCheckRxdb('dealer');
	const { result: profile } = useGetRxDb<ProfileData>('profile');

	// Check if profile is loaded and user is not RBDM
	const isProfileLoaded = profile && profile.length > 0;
	const userRole = profile[0]?.usertype_c;
	const isRBDM = userRole === 'RBDM';
	const shouldEnableQuery = isProfileLoaded && !isRBDM && isDbChecked && shouldFetch;

	const fetchDealersData = async (): Promise<Array<Dealers[]>> => {
		const response = await APIService.getData<Array<Dealers[]>>(APICONFIG.DEALERS_LIST + `?limit=${0}&version=v2`);
		if (response) {
			await setRxdb('dealer', response);
		}
		return response;
	};

	const { data, error, isLoading, isPending, refetch } = useQuery({
		queryKey: ['dealersList'],
		queryFn: fetchDealersData,
		enabled: shouldEnableQuery,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		refetch,
	};
};
